import { Selector, State } from '@ngxs/store';
import { Injectable } from '@angular/core';
import _ from 'lodash';
import { WebViewerSettingState } from '../../../brick-settings/specific-brick-settings/webviewer/webviewer-settings.state';
import { ClientPhoneState } from 'src/app/store/samwin/client-phone/client-phone.state';

export interface WebViewerBehaviourStateModel {
   [brickInstanceId: string]: WebViewerBehaviourInstance;
}

// tslint:disable-next-line:no-empty-interface
export interface WebViewerBehaviourInstance {}

@State<WebViewerBehaviourStateModel>({
   name: 'webViewerBehaviour',
   defaults: {},
})
@Injectable()
export class WebViewerBehaviourState {
   constructor() {}

   @Selector([WebViewerSettingState.getTagDrivenURLSetting, WebViewerSettingState.getUseSkillURL, ClientPhoneState.getCurrentSkillUrl])
   public static getTemplateUrlForBrickInstanceFn(
      tagDrivenUrlSettingsFn: (brickInstanceId: string) => string,
      getUseSkillURL: (brickInstanceId: string) => boolean,
      getCurrentSkillUrl: string
   ) {
      return (brickInstanceId: string) => {
         let urlTemplate: string;
         if (getUseSkillURL(brickInstanceId)) {
            urlTemplate = getCurrentSkillUrl;
         } else {
            urlTemplate = tagDrivenUrlSettingsFn(brickInstanceId);
         }
         return urlTemplate;
      };
   }
}
